/**
 * Helper functions for getting, setting and deleting cookies.
 *
 * @module CookieHelper
 * @author EN GARDE (Martin Holler, David Hell)
 * @version 1.3
 *
 * Changelog:
 * v1.3	added getCookies, fixed issue when there are multiple cookies with the same name
 * v1.2	fixed issue when setting cookie to a falsy value
 * v1.0	initial version
 */

var EN = EN || {};

EN.CookieHelper = (function () {
	'use strict';

	/**
	 * Returns all cookies as an object. If the value is valid JSON, it will be decoded.
	 * If there are multiple cookies with the same name, the last one in document.cookie will be returned.
	 * @memberof module:CookieHelper
	 * @return {object}
	 */
	var getCookies = function () {
		var cookies = document.cookie.split('; ').reduce(function(prev, current) {
		    var parts = current.split('=');
		    prev[parts[0]] = parts[1];
		    return prev;
		}, {});

		for (var i in cookies) {
			if (cookies.hasOwnProperty(i)) {
				try {
					cookies[i] = JSON.parse(cookies[i]);
				}
				catch (e) {}
			}
		}
		return cookies;
	};

	/**
	 * Gets the value of a cookie.
	 * @memberof module:CookieHelper
	 * @param {string} name
	 * @return {object|string|undefined}
	 */
	var getCookie = function (name) {
		return getCookies()[name];
	};

	/**
	 * Sets a cookie.
	 * @memberof module:CookieHelper
	 * @param {string} name
	 * @param {mixed} value - If the given value is not a string, it will be encoded as JSON.
	 * @param {date|number} [expires] - How long the cookie will be valid. Can either be a date or a number (which will be in hours from now).
	 * @return {string}
	 */
	var setCookie = function (name, value, expires) {
		if (!name) {
			return value;
		}

		value = (typeof value !== 'undefined') ? value : 1;
		expires = expires || new Date('2038-01-01');

		// JSON-encode objects
		if (typeof value === 'object') {
			try {
				value = JSON.stringify(value);
			}
			catch (err) {
			}
		}

		if (typeof expires === 'number') {
			var date = new Date();
			date.setTime(date.getTime() + (expires * 60 * 60 * 1000));
			expires = '; expires=' + date.toUTCString();
		}
		else {
			expires = '; expires=' + expires.toUTCString();
		}

		document.cookie = name + '=' + value + expires + '; path=/';

		return value;
	};

	/**
	 * Deletes a cookie.
	 * @memberof module:CookieHelper
	 * @param {string} name
	 */
	var deleteCookie = function (name) {
		setCookie(name, '', -1);
	};

	// exports
	return {
		getCookies: getCookies,
		getCookie: getCookie,
		setCookie: setCookie,
		deleteCookie: deleteCookie
	};
}());
